var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 36,
    viewBox: "0 0 80 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4288 35.1854C40.498 35.3587 40.6579 35.4791 40.8436 35.4975C41.0293 35.516 41.2098 35.4296 41.3118 35.2733C44.6707 30.1269 50.6038 22.2515 57.4722 15.3708C64.3623 8.46826 72.1052 2.65813 79.0823 1.49317C79.3464 1.44908 79.5289 1.2048 79.4963 0.93906C79.4636 0.673323 79.2275 0.480448 78.9606 0.501556C71.4279 1.09731 53.4523 5.67897 40.9691 19.2597C36.6953 12.6089 23.3972 0.5 1 0.5C0.761593 0.5 0.556348 0.668321 0.509675 0.902114C0.463002 1.13591 0.587885 1.37013 0.808017 1.46167C6.0332 3.63452 14.3023 7.9392 22.0906 13.7773C29.8881 19.6223 37.1449 26.961 40.4288 35.1854Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird2);
export default __webpack_public_path__ + "static/media/bird 2.88f136cce33389a959ec07f62932a3c4.svg";
export { ForwardRef as ReactComponent };